import { useState } from "react";
import { legends } from "@/mocks/legend";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function LegendSection() {
  const [open, setOpen] = useState<string | null>(legends[0].id);

  return (
    <section id="legend" className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <Reveal className="lg:col-span-4">
            <div className="lg:sticky lg:top-24">
              <SectionHeading
                eyebrow="野史解读"
                title="潘金莲野史解读四个常见话题"
                desc="围绕潘金莲的野史与民间说法不少，它们未必都能被证实地当作史实，但确实影响了一代代观众对她的想象。下面几条是流传最广的。"
              />
              <div className="mt-6 flex items-start gap-3 rounded-lg border border-primary-200 bg-primary-50 p-4">
                <span className="shrink-0 w-6 h-6 flex items-center justify-center text-primary-600">
                  <i className="ri-alert-line"></i>
                </span>
                <p className="text-xs md:text-sm leading-relaxed text-primary-900">
                  以下内容属野史与民间讲述，供了解流传脉络之用，不视为已被证实的历史事实。
                </p>
              </div>
            </div>
          </Reveal>

          <div className="lg:col-span-8 space-y-3">
            {legends.map((item, idx) => {
              const isOpen = open === item.id;
              return (
                <Reveal key={item.id} delay={idx * 50}>
                  <div className="rounded-lg border border-background-200 bg-background-100 overflow-hidden">
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? null : item.id)}
                      aria-expanded={isOpen}
                      className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-200/60 transition-colors"
                    >
                      <span className="flex items-center gap-3">
                        <span className="w-7 h-7 shrink-0 flex items-center justify-center rounded-md bg-accent-100 font-label text-xs text-accent-900">
                          {idx + 1}
                        </span>
                        <span className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                          {item.title}
                        </span>
                      </span>
                      <i
                        className={`shrink-0 text-lg text-foreground-500 transition-transform ${
                          isOpen ? "ri-subtract-line" : "ri-add-line"
                        }`}
                      ></i>
                    </button>
                    {isOpen ? (
                      <div className="px-5 pb-5 pl-16">
                        <p className="text-sm md:text-[15px] leading-relaxed text-foreground-700">
                          {item.text}
                        </p>
                      </div>
                    ) : null}
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}